/**
 *
 * ConfigPage constants
 *
 */

export const __DEBUG__ = true; // TODO: set actual env.

export const SUBMIT = 'Sitemap/ConfigPage/SUBMIT';
export const ON_SUBMIT_SUCCEEDED = 'Sitemap/ConfigPage/ON_SUBMIT_SUCCEEDED';
export const SUBMIT_MODAL = 'Sitemap/ConfigPage/SUBMIT_MODAL';
export const DELETE_CONTENT_TYPE = 'Sitemap/ConfigPage/DELETE_CONTENT_TYPE';
export const DELETE_CUSTOM_ENTRY = 'Sitemap/ConfigPage/DELETE_CUSTOM_ENTRY';
export const ON_CHANGE_CONTENT_TYPES = 'Sitemap/ConfigPage/ON_CHANGE_CONTENT_TYPES';
export const GENERATE_SITEMAP = 'Sitemap/ConfigPage/GENERATE_SITEMAP';
export const UPDATE_SETTINGS = 'Sitemap/ConfigPage/UPDATE_SETTINGS';
export const ON_CHANGE_SETTINGS = 'Sitemap/ConfigPage/ON_CHANGE_SETTINGS';
export const DISCARD_ALL_CHANGES = 'Sitemap/ConfigPage/DISCARD_ALL_CHANGES';
export const DISCARD_MODIFIED_CONTENT_TYPES = 'Sitemap/ConfigPage/DISCARD_MODIFIED_CONTENT_TYPES';
export const GET_SETTINGS = 'Sitemap/ConfigPage/GET_SETTINGS';
export const GET_SETTINGS_SUCCEEDED = 'Sitemap/ConfigPage/GET_SETTINGS_SUCCEEDED';
export const GET_CONTENT_TYPES = 'Sitemap/ConfigPage/GET_CONTENT_TYPES';
export const GET_CONTENT_TYPES_SUCCEEDED = 'Sitemap/ConfigPage/GET_CONTENT_TYPES_SUCCEEDED';
export const GET_LANGUAGES_SUCCEEDED = 'Sitemap/ConfigPage/GET_LANGUAGES_SUCCEEDED';
export const HAS_SITEMAP = 'Sitemap/ConfigPage/HAS_SITEMAP';
export const GET_SITEMAP_INFO_SUCCEEDED = 'Sitemap/ConfigPage/GET_SITEMAP_INFO_SUCCEEDED';
export const ON_CHANGE_CUSTOM_ENTRY = 'Sitemap/ConfigPage/ON_CHANGE_CUSTOM_ENTRY';
export const GET_ALLOWED_FIELDS_SUCCEEDED = 'Sitemap/ConfigPage/GET_ALLOWED_FIELDS_SUCCEEDED';
export const SET_LOADING_STATE = 'Sitemap/ConfigPage/SET_LOADING_STATE';
export const DEFAULT_LANGUAGE_URL_TYPE_DEFAULT_LOCALE = 'default-locale';
export const DEFAULT_LANGUAGE_URL_TYPE_OTHER = 'other';
